import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const MONEDAS_CONST = 'monedas';
export const monedas_api = `${baseUrl}/sistema/${MONEDAS_CONST}`;

export const allMonedasService = async (params) => {
  const res = await axios.get(monedas_api, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveMonedasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${monedas_api}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(monedas_api, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneMonedasService = async (id) => {
  const res = await axios.get(`${monedas_api}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteMonedasService = async (id) => {
  const res = await axios.delete(`${monedas_api}/${id}`, {
    headers: token({}),
  });
  return res;
};
